import { useSelector } from "react-redux";

// Hard-coding message for now, eventually we'll want to switch based on the contents
// of `smBagError`
const DEFAULT_ERROR_MSG = "There was a problem adding this item to your bag. Please refresh and try again.";

export default function AddToBagError() {
  const smBagError = useSelector(state => state.smBag?.smBagError);

  if (!smBagError) {
    return;
  }

  return <div className="mt-6 p-3 bg-lightMutedRed">{DEFAULT_ERROR_MSG}</div>;
}
